/*
 * This file is part of glowingblue/gamilytics.
 *
 * Copyright (c) 2023 Glowing Blue AG.
 * Authors: Rafael Horvat.
 *
 * For the full copyright and license information, please view the LICENSE.md
 * file that was distributed with this source code.
 */

import app from 'flarum/forum/app';
import Notification from 'flarum/forum/components/Notification';
import { slug } from '../../../common';
const t = function () {
  return app.translator.trans(...arguments);
};
const prfx = `${slug}.forum.notifications`;
export default class LevelChangedNotification extends Notification {
  icon() {
    return 'fas fa-diamond';
  }
  href() {
    return app.route.user(this.attrs.notification?.fromUser());
  }
  content() {
    const {
      notification
    } = this.attrs;
    const currentLevel = notification?.content()?.level;
    const previousLevel = notification?.content()?.previousLevel;
    const levelUp = currentLevel > previousLevel;
    return t(`${prfx}.level_${levelUp ? 'up' : 'down'}_text`, {
      display_name: notification?.fromUser()?.displayName(),
      level: notification?.content()?.level
    });
  }
  excerpt() {
    return null;
  }
}
flarum.reg.add('glowingblue-gamilytics', 'forum/levels/components/LevelChangedNotification', LevelChangedNotification);